import React from "react";
import { Line } from "react-chartjs-2";
import { FormatNumber } from "../../helpers";

const COLOR_INCOME = "#16a34a";
const COLOR_EXPENSE = "#dc3545";
const COLOR_INK_MUTED = "#9ca3af";
const COLOR_INK_SOFT = "#4a4a4a";
const COLOR_GRID = "rgba(0, 0, 0, 0.06)";

const formatCompact = (n) => {
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) {
    return (n / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + " M";
  }
  if (abs >= 1_000_000) {
    return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + " jt";
  }
  if (abs >= 1_000) return Math.round(n / 1_000) + "k";
  return String(n);
};

const LineChart = (props) => {
  const { months, trx } = props;

  // Chronological order: oldest left, newest right
  const sorted = [...trx].sort((a, b) => (a.m || 0) - (b.m || 0));
  const positive = sorted.map((d) => d.positive || 0);
  const negative = sorted.map((d) => Math.abs(d.negative || 0));
  const max = Math.max(...positive, ...negative, 1);

  const baseDataset = {
    pointBackgroundColor: "#fff",
    pointBorderWidth: 2,
    pointRadius: 4,
    pointHoverRadius: 6,
    pointHoverBorderColor: "#fff",
    borderWidth: 2.5,
    lineTension: 0.35,
    fill: true,
  };

  const data = {
    labels: sorted.map((d) => `${months[d.month - 1]} ${d.year}`),
    datasets: [
      {
        ...baseDataset,
        label: "Pemasukan",
        data: positive,
        borderColor: COLOR_INCOME,
        backgroundColor: "rgba(22, 163, 74, 0.12)",
        pointBorderColor: COLOR_INCOME,
        pointHoverBackgroundColor: COLOR_INCOME,
      },
      {
        ...baseDataset,
        label: "Pengeluaran",
        data: negative,
        borderColor: COLOR_EXPENSE,
        backgroundColor: "rgba(220, 53, 69, 0.10)",
        pointBorderColor: COLOR_EXPENSE,
        pointHoverBackgroundColor: COLOR_EXPENSE,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    layout: { padding: { top: 8, right: 6, bottom: 0, left: 0 } },
    legend: {
      position: "top",
      align: "end",
      labels: {
        usePointStyle: true,
        boxWidth: 8,
        padding: 14,
        fontFamily: "inherit",
        fontSize: 11,
        fontColor: COLOR_INK_SOFT,
      },
    },
    tooltips: {
      mode: "index",
      intersect: false,
      backgroundColor: "rgba(26, 26, 26, 0.95)",
      titleFontFamily: "inherit",
      bodyFontFamily: "inherit",
      titleFontSize: 12,
      titleFontStyle: "600",
      bodyFontSize: 12,
      titleSpacing: 4,
      bodySpacing: 4,
      cornerRadius: 8,
      xPadding: 10,
      yPadding: 8,
      caretSize: 5,
      displayColors: true,
      callbacks: {
        label(item, d) {
          const label = d.datasets[item.datasetIndex].label;
          return ` ${label}: Rp ${FormatNumber(Math.round(item.yLabel))}`;
        },
      },
    },
    hover: { mode: "index", intersect: false },
    scales: {
      yAxes: [
        {
          ticks: {
            min: 0,
            max: Math.ceil(max * 1.15),
            maxTicksLimit: 5,
            fontFamily: "inherit",
            fontSize: 10,
            fontColor: COLOR_INK_MUTED,
            padding: 6,
            callback(value) {
              return formatCompact(value);
            },
          },
          gridLines: {
            color: COLOR_GRID,
            drawBorder: false,
            zeroLineColor: COLOR_GRID,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontFamily: "inherit",
            fontSize: 10,
            fontColor: COLOR_INK_MUTED,
            padding: 4,
            maxRotation: 0,
            autoSkipPadding: 20,
          },
          gridLines: { display: false, drawBorder: false },
        },
      ],
    },
    animation: { duration: 600, easing: "easeOutCubic" },
  };

  return (
    <div style={{ height: 240, marginTop: "0.25rem" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
